export default __webpack_public_path__ + "static/media/East-Kerala.a11a5dca.png";